import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import type {PageType} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceConfig";
import {resolveConfigPageIdByType} from "~/workspaceConfig/configPageIds";
import {configPageHref, CONFIG_PAGE_ROUTE_TO} from "~/workspaceConfig/configPageRoutes";

export function configPageNavigation(workspaceId: Uuid | string, pageType: PageType, search: Record<string, unknown> = {}) {
    return {to: CONFIG_PAGE_ROUTE_TO, params: {workspaceId, pageKey: resolveConfigPageIdByType(workspaceId, pageType)}, search};
}

export function requiredConfigPageHref(workspaceId: Uuid | string, pageType: PageType): string {
    const navigation = configPageNavigation(workspaceId, pageType);
    return configPageHref(workspaceId, navigation.params.pageKey);
}
